import { render, staticRenderFns } from "./sendOenology.vue?vue&type=template&id=5227b032&"
import script from "./sendOenology.vue?vue&type=script&lang=js&"
export * from "./sendOenology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports